import styled from 'styled-components'

import { useSvgHref } from '../../svgHrefContext'

import * as icon from '../Icon'

const SYMBOL_ID = 'icon-sliders-def'

FullSliders.filename = SYMBOL_ID
export function FullSliders(props: icon.SpecificIconProps): React.ReactElement {
    return (
        <icon.Icon {...props} name="sliders">
            <defs>
                <g id={SYMBOL_ID}>
                    <path d="M5 2V11H3V2H5ZM5 15V22H3V15H0V13H3H5H8V15H5ZM13 22V11H11V22H13ZM13 2V7H16V9H13H11H8V7H11V2H13ZM21 22V17H24V15H21H19H16V17H19V22H21ZM21 2V13H19V2H21Z" />
                </g>
            </defs>
            <use href={`#${SYMBOL_ID}`} />
        </icon.Icon>
    )
}

export const Sliders = styled(function Sliders(
    props: icon.SpecificIconProps
): React.ReactElement {
    const href = useSvgHref(SYMBOL_ID)
    return (
        <icon.Icon {...props} name="sliders">
            <use href={href} />
        </icon.Icon>
    )
})``
